<template>
    <div>
      <v-menu offset-y>
        <template v-slot:activator="{ attrs, on }">
            <v-btn
              class="white--text mb-2 mr-3"
              v-bind="attrs"
              v-on="on"
              color="blue-grey"
              :loading="actionInProgress"
              :disabled="actionInProgress"
          >
              actions
              <v-icon right dark> mdi-tray-arrow-up</v-icon>
          </v-btn>
        </template>

        <v-list class="pa-0">
          <v-list-item
              v-for="(item, index) in actions"
              :key="index"
              link
          >
              <v-list-item-title
                  v-text="item"
                  @click="onSelectAction(item)"
              ></v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
</template>

<script>
import reports from "@/mixins/reports";
import download from "downloadjs";


export default {  
  mixins: [reports],
  props: {
    reportOptions: {},
    downloadFilename: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    msg: false,
    text: "",
    actionInProgress: false,
    actions: ["Print", "Download"],
  }),
  created() {
  },
  methods: {
    async onSelectAction(action) {
        try {
            this.actionInProgress = true

            if (action === 'Print') {
              await this.getReport(this.reportOptions);
            } else {
              const response = await this.generateDynamicReport(this.reportOptions)
              download(response.data, `${this.downloadFilename}.pdf`, "application/pdf");
            }
            this.actionInProgress = false;

        } catch (e) {
            this.msg = true
            this.text = "An error occured"
            this.actionInProgress = false
        } 

    },
  }
}
</script>